import { render, staticRenderFns } from "./Picturecard_area.vue?vue&type=template&id=7585dc23&scoped=true&"
import script from "./Picturecard_area.vue?vue&type=script&lang=js&"
export * from "./Picturecard_area.vue?vue&type=script&lang=js&"
import style0 from "./Picturecard_area.vue?vue&type=style&index=0&id=7585dc23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7585dc23",
  null
  
)

export default component.exports